import { ICampaign } from '@user/store/campaigns'
import { IDivision } from '@user/store/divisions/typings'
import { ILocationType } from '@user/store/locationTypes/typings'
import { IServiceFrequency } from '@user/store/serviceFrequency'
import { ISource } from '@user/store/sources'
import { ITargetPest } from '@user/store/targetPests/typings'
import { useCallback } from 'react'

export function useAssignIds(
  allSources: ISource[],
  allCampaigns: ICampaign[],
  allTargetPests: ITargetPest[],
  allLocationTypes: ILocationType[],
  allDivisions: IDivision[],
  allServiceFrequencies: IServiceFrequency[],
) {
  const assignOtherIds = useCallback(
    (record) => {
      const newRecord = { ...record }
      const {
        source,
        sourceId,
        campaign,
        campaignId,
        targetPest,
        targetPestId,
        locationType,
        locationTypeId,
        division,
        divisionId,
        frequencyName,
        frequencyId,
        annualOccurrences,
      } = newRecord.row

      const assignId = (
        entity,
        entityId,
        collection,
        ignoreDescription: boolean = false,
        entityProp = 'name',
      ) => {
        if (!entity) return

        entityId.value =
          collection.find((x) =>
            ignoreDescription
              ? x[entityProp] === entity?.value
              : x.description
              ? entity?.value === `${x.name} - ${x.description}`
              : x[entityProp] === entity?.value,
          )?.id ?? ''
      }

      assignId(source, sourceId, allSources)
      assignId(campaign, campaignId, allCampaigns)
      assignId(targetPest, targetPestId, allTargetPests, true)
      assignId(locationType, locationTypeId, allLocationTypes)
      assignId(division, divisionId, allDivisions)

      if (frequencyId && frequencyName) {
        const frequency = allServiceFrequencies.find(
          (x) =>
            `${x.annualOccurrences} - ${x.description}` ===
            frequencyName?.value,
        )

        frequencyId.value = frequency?.id ?? ''
        annualOccurrences.value = frequency?.annualOccurrences ?? ''
      }

      return newRecord
    },
    [
      allSources,
      allCampaigns,
      allTargetPests,
      allLocationTypes,
      allDivisions,
      allServiceFrequencies,
    ],
  )

  return {
    assignOtherIds,
  }
}
